module.exports = {
  content: [
    "./index.html",
    "./public/**/*.html",
    "./src/**/*.{vue,js,ts,jsx,tsx}",
  ],
  important: true,
  theme: {
    extend: {
      fontSize: {
        xs: ["0.813rem", "1rem"],
      },
    },
    colors: {
      transparent: "transparent",
      current: "currentColor",
      "pale-green": "#D1EAFF",
      "light-green": "#35A6FA",
      "ligher-green": "#EEF7FF",
      green: "#038FF8",
      "dark-green": "#0270C4",
      "darkest-green": "#191D47",
      "light-blue": "#B2DEFF",
      blue: "#038FF8",
      orange: "#F76B1B",
      yellow: "#FFF8E5",
      "dark-yellow": "#FFBB00",
      white: "#FFFFFF",
      "off-white": "#F5F6F8",
      black: "#191D47",
      gray: "#9AA0AE",
      "dark-gray": "#5B6070",
      "very-dark-gray": "#191D47",
      "light-gray": "#F5F6F8",
      "light-gray-stroke": "#E3E5EA",
      "avail-green": {
        50: "#EEF7FF",
        100: "#D1EAFF",
        200: "#B2DEFF",
        300: "#7CC5FC",
        400: "#35A6FA",
        500: "#038FF8",
        600: "#0277D0",
        700: "#025FA6",
        800: "#03497F",
        900: "#0B3460",
      },
      red: "#ED2929",
      ink: "#191D47",
      slate: "#5B6070",
      purple: "#8856FF",
      pink: "#ED489E",
      "brand-green": "#00CC6B",
      "tint-purple": "#F2EBFF",
      "tint-pink": "#FFE8F4",
      "tint-green": "#E5FFF2",
      "tint-orange": "#FEF1E6",
      "indigo-end": "#2C1169",
    },
    screens: {
      sm: "640px",
      md: "768px",
      mdlg: "896px",
      lg: "1024px",
      xl: "1280px",
      "2xl": "1536px",
    },
  },
  plugins: [],
  prefix: "tw-",
  safelist: [],
}
